import { createStyles, Theme } from '@material-ui/core'

const sideHelpWidth = 500

export const styles = (theme: Theme) =>
  createStyles({
    drawerRoot: {
      '& .MuiDrawer-paper': {
        [theme && theme.breakpoints.down('sm')]: {
          width: '100%'
        },
        width: sideHelpWidth
      }
    },
    sideHelpContainer: {
      [theme && theme.breakpoints.down('sm')]: {
        width: '100%'
      },
      width: sideHelpWidth,
      '& *:focus': {
        outline: 'none !important'
      }
    },
    cardRoot: {
      height: 'calc(100vh - 43px)',
      overflowY: 'auto',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between'
    }
  })
